import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { ROLE_LABELS } from "./RoleScopeBanner";

const LABELS = { admin: "Διαχειριστής", user: "Χρήστης (Γραμματεία)", judge: "Δικαστής", dispatch: "Προσωπικό Διακίνησης", katastima: "Κατάστημα", ...ROLE_LABELS };
export const roleLabel = (r) => LABELS[r] || r;

const SHORT = { admin: "Διαχειριστής", user: "Γραμματεία", judge: "Δικαστής", dispatch: "Διακίνηση", katastima: "Κατάστημα",
  sector_head_poly: "Υπεύθ. Τομέα Πολυμελούς", sector_head_mono: "Υπεύθ. Τομέα Μονομελούς", composition_president: "Πρόεδρος Σύνθεσης" };
const COLORS = { admin: "bg-slate-800 text-white border-slate-800", user: "bg-slate-100 text-slate-700 border-slate-300",
  judge: "bg-sky-100 text-sky-800 border-sky-300", dispatch: "bg-amber-100 text-amber-800 border-amber-300", katastima: "bg-lime-100 text-lime-800 border-lime-300",
  sector_head_poly: "bg-indigo-100 text-indigo-800 border-indigo-300", sector_head_mono: "bg-teal-100 text-teal-800 border-teal-300",
  composition_president: "bg-rose-100 text-rose-800 border-rose-300" };

// iter94: χρωματιστό badge ενεργής ιδιότητας (κεφαλίδα) — click → αλλαγή ιδιότητας για multi-role
export const ActiveRoleBadge = ({ user, onClick }) => {
  const role = user?.role;
  if (!role) return null;
  const multi = (user?.roles || []).length > 1;
  const cls = `inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${COLORS[role] || COLORS.user}`;
  const title = `Ενεργή ιδιότητα: ${roleLabel(role)}${multi ? " — κλικ για αλλαγή" : ""}`;
  return multi ? (
    <button type="button" onClick={onClick} title={title} data-testid="active-role-badge"
            className={`${cls} cursor-pointer transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-slate-400`}>
      {SHORT[role] || role}<span aria-hidden className="opacity-60">⇄</span>
    </button>
  ) : (
    <span title={title} data-testid="active-role-badge" className={cls}>{SHORT[role] || role}</span>
  );
};

// iter94: επιλογή ιδιότητας (προφίλ) στη σύνδεση / αλλαγή ιδιότητας για χρήστες με πολλούς ρόλους
export const RoleChooser = ({ open, roles, current, onSelect, onClose, busy }) => (
  <Dialog open={open} onOpenChange={(v) => { if (!v && onClose) onClose(); }}>
    <DialogContent data-testid="role-chooser-dialog">
      <DialogHeader>
        <DialogTitle>Επιλέξτε ιδιότητα</DialogTitle>
        <DialogDescription>Ο λογαριασμός σας έχει περισσότερες από μία ιδιότητες. Με ποια θέλετε να συνδεθείτε;</DialogDescription>
      </DialogHeader>
      <div className="grid gap-2 py-2">
        {(roles || []).map(r => (
          <Button key={r} variant={r === current ? "default" : "outline"} className="justify-start h-auto py-3 whitespace-normal text-left"
                  disabled={busy} onClick={() => onSelect(r)} data-testid={`role-choice-${r}`}>
            {roleLabel(r)}{r === current ? " (τρέχουσα)" : ""}
          </Button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export default RoleChooser;
